export default __webpack_public_path__ + "static/media/20.e6f6db19.png";